import { useState, useEffect, useMemo, forwardRef } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  ListSubheader,
  TextField,
  InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getAllTasks } from 'src/services/timeManagementService';

interface ReferenceIdMultiSelectProps {
  value: string[] | [],
  onChange: (e: any) => void,
  projectId: string,
}

const ReferenceIdMultiSelect = forwardRef((props: ReferenceIdMultiSelectProps, _ref) => {
  const [list, setList] = useState([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [searchText, setSearchText] = useState<string>('');
  
  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  const fetchLists = () => {
    const payload = {
      projectId: props?.projectId,
      endDate: null,
      startDate: null,
      taskId: null,
      taskName: null,
      taskTypeId: null,
      status: null,
      referenceId: null
    }
    getAllTasks(payload).then((res) => {
      const data = res?.data?.data
      setList(data?.taskSummery);
    });
  }

  const filteredLists = useMemo(
    () =>
      list.length > 0 &&
    list?.filter((option) => containsText(option?.referenceId, searchText)),
    [list, searchText]
  );

  useEffect(() => {
    const selectedName = [];
    if(props?.value && props?.value.length > 0){
      for(let i=0; i < props?.value.length; i++){
        const result = list.filter(e => e.referenceId === props?.value[i]);
        selectedName.push(result[0]?.referenceId);
      }
    }
    setSelectedItems(selectedName);
  }, [list, props?.value]);

  return (
    <FormControl fullWidth>
      <InputLabel
        style={{
          fontSize: '12px'
        }}
      >
        Reference Id
      </InputLabel>
      <Select
        id="filter-resource"
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        multiple
        size="small"
        value={props.value}
        renderValue={() => selectedItems.join(', ')}
        onChange={(e) => props?.onChange(e)}
        onClose={() => setSearchText('')}
        onOpen={fetchLists}
      >
        <ListSubheader>
          <TextField
            id="search-task-id"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>
        {
          filteredLists?.length > 0 &&
          filteredLists.map((fl, i) => {
            return (
              <MenuItem key={fl?.referenceId} 
                value={fl?.referenceId}>
                  <Checkbox checked={props?.value.indexOf(fl?.referenceId as never) > -1} />
                  <ListItemText primary={fl?.referenceId} />
              </MenuItem>
            );
          })
        }
      </Select>
    </FormControl>
  );
});

export default ReferenceIdMultiSelect;
